import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, TableFilter, EmptyState, BaasicButton } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content } from 'core/layouts';
import { isSome } from 'core/utils';

function ProductTypeListTemplate({ productTypeListViewStore }) {
    const {
        tableLoading,
        tableStore,
        queryUtility,
        authorization
    } = productTypeListViewStore;
    return (
        <ApplicationListLayout store={productTypeListViewStore}>
            <Content emptyRenderer={renderEmpty()} >
                <div className='u-mar--bottom--sml'>
                    <TableFilter queryUtility={queryUtility} />
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        authorization={authorization}
                        actionsComponent={renderActions}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='PRODUCT_TYPE.LIST.EMPTY_STATE.TITLE' description='PRODUCT_TYPE.LIST.EMPTY_STATE.DESCRIPTION' />
}

ProductTypeListTemplate.propTypes = {
    productTypeListViewStore: PropTypes.object
};

function renderActions({ item, actions, authorization }) {
    if (!isSome(actions)) return null;

    const { onEdit, onDelete } = actions;
    if (!isSome(onEdit) && !isSome(onDelete)) return null;
    return (
        <td className="table__body--data right">
            <div className="table__icons">              
                {isSome(onEdit) ?  (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--edit u-icon--sml'
                        label='FACILITY_INVENTORY.LIST.BUTTON.EDIT'
                        onlyIcon={true}
                        disabled={item.isSystem}
                        onClick={() => onEdit(item)}>
                    </BaasicButton>
                ) : null}                
                {isSome(onDelete) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.delete : null}
                        className="btn btn--icon is-delete"
                        icon='u-icon u-icon--delete--primary u-icon--sml'
                        label='FACILITY_INVENTORY.LIST.BUTTON.DELETE'
                        onlyIcon={true}
                        disabled={item.isSystem}
                        onClick={() => onDelete(item)}>
                    </BaasicButton>
                ) : null}
            </div>
        </td>
    )
}

renderActions.propTypes = {
    item: PropTypes.object,
    actions: PropTypes.object,
    authorization: PropTypes.any
};

export default defaultTemplate(ProductTypeListTemplate);
